module.exports = __webpack_public_path__ + "static/media/2019_conf _Iterating_Toward_a_Better_Product_Culture.707e6ac0.png";